import React, { useEffect, useState, useContext } from "react";
import { Select } from 'antd';
import Switch from "./AndOrToggleSwtich";
import ToggleButton from "./ToggleAndOrSwitch";
import { PeFilterContext } from "../../Contexts/PeFilterContext";

const options = [
  { value: "currentRatio", label: "Current Ratio", min: "", max: "", filterKey: "current_ratio" },
  { value: "quickRatio", label: "Quick Ratio", min: "", max: "", filterKey: "quick_ratio" },
  { value: "debtEquityRatio", label: "Debt Equity Ratio", min: "", max: "", filterKey: "debt_equity_ratio" },
  { value: "roe", label: "RoE", min: "", max: "", filterKey: "roe" },
  { value: "roa", label: "RoA", min: "", max: "", filterKey: "roa" },
  { value: "roce", label: "RoCE", min: "", max: "", filterKey: "roce" },
  { value: "assetTurnoverRatio", label: "Asset Turnover Ratio", min: "", max: "", filterKey: "asset_turnover_ratio" },
  { value: "operating_margin", label: "Operating Margin", min: "", max: "", filterKey: "operating_margin" },
  { value: "ebitdaMargin", label: "EBITDA Margin", min: "", max: "", filterKey: "ebitda_margin" },
  { value: "patMargin", label: "PAT Margin", min: "", max: "", filterKey: "pat_margin" },
  { value: "contribution Margin", label: "Contribution Margin", min: "", max: "", filterKey: "contribution_margin" },
];
/**
 * The RatiosBasedFilter component is a JavaScript function that renders a filter component for
 * refining search results based on ratios.
 * @returns The RatiosBasedFilter component is being returned.
 */
const RatiosBasedFilter = ({
  open,
  accordionClick,
  RatioYear,
  setRatioYear,
  RatioYearOptions,
  setRatioYearOptions,
  RatioAndOr,
  setRatioAndOr,
  customPathname,
  label = "Ratios Based",
  isPopupOpen,
  setIsPopupOpen
}) => {
  const { refineSearchFilters } = useContext(PeFilterContext);

  /* The `useEffect` hook is used to perform side effects in a functional component. In this case, the
  `useEffect` hook is used to update the state variables `RatioYear`, `RatioYearOptions`, and
  `RatioAndOr` based on the values stored in the `refineSearchFilters` context. */
  useEffect(() => {
    const ratioYear = refineSearchFilters[customPathname]?.ratioYear?.at(0)?.value;
    const ratioOptions = refineSearchFilters[customPathname]?.ratioPercentage?.map(option => option.value);
    const ratioAnd = refineSearchFilters[customPathname]?.ratioOperator?.at(0)?.value ?? 'or'
    setRatioYear(ratioYear ?? "any")
    setRatioYearOptions(ratioOptions ?? []);
    setRatioAndOr(ratioAnd);
  }, [customPathname, refineSearchFilters, setRatioAndOr, setRatioYear, setRatioYearOptions])

  /**
   * The function `onRatioYearChange` sets the value of `RatioYear` to the provided `value`.
   * @param value - The value parameter is the new value that will be set for the ratio year.
   */
  const onRatioYearChange = (value) => {
    // setRatioYear(prev => prev === value ? null : value)
    setRatioYear(value)
    // setGrowthOptions([])
  }

  /**
   * The function `onRationOptionChange` updates the ratio year options based on the selected ratios.
   * @param e - The parameter "e" is an event object that represents the event that triggered the
   * change. It could be an input change event, a button click event, or any other type of event.
   * @param selectedRatios - The selectedRatios parameter is a variable that represents the selected
   * ratios in a form or input field. It could be an array, object, or any other data type depending on
   * how the ratios are being stored or retrieved.
   */
  const onRationOptionChange = (e, selectedRatios) => {
    setRatioYearOptions(selectedRatios)
  }


  /**
   * The function `onOptionsYearChange` is used to handle changes in the year options and update the
   * corresponding values in the `RatioYearOptions` array.
   * @param index - The index parameter represents the index of the element in the RatioYearOptions
   * array that needs to be updated.
   * @param optionKey - The `optionKey` parameter represents the key of the option being changed. It
   * can have two possible values: "min" or "max".
   * @param value - The `value` parameter represents the new value that is being entered or selected
   * for the options year.
   * @param key - The `key` parameter is not used in the provided code snippet. It is not clear what
   * its purpose is without further context.
   */
  const onOptionsYearChange = (index, optionKey, value, key) => {
    const validNumber = new RegExp(/^\d*\.?\d*$/);
    let processedValue = "";
    if (validNumber.test(value)) {
      processedValue = value;
    } else {
      processedValue = optionKey === "min" ? RatioYearOptions[index].min : RatioYearOptions[index].max;
    }
    setRatioYearOptions(prev => {
      let temp = [...prev];
      if (optionKey === "min") {
        temp[index].min = processedValue
      } else if (optionKey === "max") {
        temp[index].max = processedValue
      }
      return temp;
    })
  }

  const getSelectedCount = () => {
    return RatioYearOptions?.filter(option => option.min !== "" && option.max !== "").length || 0;
  };

  return (
    <div className="px-4 bg-white">
      <h3 className="text-lg font-semibold mb-4 text-[#333333] flex items-center justify-between">
        <span>{label}</span>
        {getSelectedCount() > 0 && (
          <span className="bg-[#BC8B20] text-white text-xs rounded-full px-2 py-1 min-w-[20px] text-center">
            {getSelectedCount()}
          </span>
        )}
      </h3>

      <div className="space-y-4">
        <div className="flex items-center gap-4">
          <label className="font-semibold text-sm text-[#333333]">Year:</label>
          <div className="flex gap-3">
            <div className="flex items-center">
              <input
                type="radio"
                className="cursor-pointer mr-2"
                value="any"
                id="ratio-any"
                checked={RatioYear === "any"}
                onChange={() => onRatioYearChange('any')}
              />
              <label htmlFor="ratio-any" className="text-sm cursor-pointer whitespace-nowrap">
                Any of
              </label>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                value="all"
                id="ratio-all"
                className="cursor-pointer mr-2"
                checked={RatioYear === "all"}
                onChange={() => onRatioYearChange('all')}
              />
              <label htmlFor="ratio-all" className="text-sm cursor-pointer whitespace-nowrap">
                Across All
              </label>
            </div>
          </div>
        </div>

        <div>
          <Select
            mode="multiple"
            showSearch
            options={options}
            optionFilterProp='label'
            value={RatioYearOptions}
            onChange={onRationOptionChange}
            placeholder="Select ratio metrics"
            style={{
              width: '100%',
              border: '1px solid #BC8B20',
              borderRadius: '4px',
              background: '#ffffff',
              maxHeight: '60px',
              overflowY: "auto"
            }}
            bordered={false}
          />
        </div>

        {RatioYearOptions.length > 0 && (
          <div>
            <div className="grid grid-cols-3 gap-3 mb-3">
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333]">Fields</label>
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333] text-center">Greater than</label>
              <label className="whitespace-nowrap font-semibold text-sm text-[#333333] text-center">Less than</label>
            </div>

            {RatioYearOptions.map((option, i) => (
              <div key={option.value} className="grid grid-cols-3 gap-3 items-center mb-2">
                <div className="text-sm text-[#333333] font-sans_book_body">{option.label}</div>
                <div>
                  <input
                    className="border border-gray-300 rounded p-2 w-full text-sm"
                    type="text"
                    autoComplete="off"
                    required={option.max !== ""}
                    placeholder="Min"
                    value={option.min}
                    onChange={(e) => onOptionsYearChange(i, "min", e.target.value, option.value)}
                  />
                </div>
                <div>
                  <input
                    className="border border-gray-300 rounded p-2 w-full text-sm"
                    type="text"
                    autoComplete="off"
                    required={option.min !== ""}
                    placeholder="Max"
                    value={option.max}
                    onChange={(e) => onOptionsYearChange(i, "max", e.target.value, option.value)}
                  />
                </div>
              </div>
            ))}

            <hr className="my-4" />

            <div>
              <ToggleButton
                value={RatioAndOr === "or"}
                onLabel="AND"
                offLabel="OR"
                onToggle={(value) => setRatioAndOr(value)}
                from={"cfsRefineSearch"}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default RatiosBasedFilter;

